import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const UserFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.2662 9.5C13.2608 9.5 14.2146 9.10491 14.9179 8.40165C15.6211 7.69839 16.0162 6.74456 16.0162 5.75C16.0162 4.75544 15.6211 3.80161 14.9179 3.09835C14.2146 2.39509 13.2608 2 12.2662 2C11.2717 2 10.3178 2.39509 9.61459 3.09835C8.91132 3.80161 8.51624 4.75544 8.51624 5.75C8.51624 6.74456 8.91132 7.69839 9.61459 8.40165C10.3178 9.10491 11.2717 9.49999 12.2662 9.5ZM4.09749 17.6162C3.98145 17.9264 3.96864 18.2657 4.06099 18.5837C4.15333 18.9018 4.34588 19.1815 4.60999 19.3812C6.79916 21.0825 9.49371 22.0042 12.2662 22C15.1537 22 17.8137 21.02 19.93 19.375C20.4675 18.9587 20.685 18.2462 20.44 17.6125C19.8053 15.96 18.6844 14.5388 17.2254 13.5365C15.7663 12.5342 14.0376 11.9979 12.2674 11.9983C10.4973 11.9987 8.76883 12.5358 7.31023 13.5388C5.85163 14.5418 4.73144 15.9635 4.09749 17.6162Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

UserFilledIcon.displayName = 'UserFilledIcon';
